(function () {
    'use script';

    angular.createEnum = createEnum;
    angular.isPlainObject = isPlainObject;
    angular.guid = guid;
    angular.createObjectURL = createObjectURL;
    angular.revokeObjectURL = revokeObjectURL;

    function isPlainObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    function createEnum(obj) {
        var result = { $metadata: {} };
        var index = 0;

        if (!angular.isPlainObject(obj))
            throw new Error('obj must be a plain old object');

        angular.forEach(obj, function (value, key) {
            var data = { key: key };

            // Number (no metadata)
            if (angular.isNumber(value))
                data.value = value;

            // Tuple [Value, DisplayName ]
            else if (angular.isArray(value)) {
                if (!Number.isInteger(value[0]))
                    throw new Error('Tuple value #1 (value) must be an integer.');
                data.value = value[0];
                data.displayName = value[1] != null ? value[1].toString() : data.key;
            }

            // Object { value: 1, metadataX: 'x', metadataY: 123 }
            else if (angular.isObject(value)) {
                if (!Number.isInteger(value.value))
                    throw new Error('Object must have a ordinal value property.');
                angular.extend(data, value);
            }

            // Invalid
            else
                throw new Error('Invalid value.');

            if (data.displayName == null)
                data.displayName = key;
            result.$metadata[result[result[key] = data.value] = data.key] = data;
            Object.defineProperty(result, data.value, { enumerable: false });
        });
        Object.defineProperty(result, '$metadata', { enumerable: false });
        return result;
    }

    // Borrowed from: http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript?page=1&tab=votes#tab-top
    function guid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    function createBlob(arrayBuffer) {
        var result = null;
        try {
            result = new Blob([arrayBuffer]);
        }
        catch (e) {
            if (e.name === 'TypeError' && window.BlobBuilder) {
                var builder = new BlobBuilder();
                builder.append(arrayBuffer);
                result = builder.getBlob();
            }
        }
        return result;
    }

    function createObjectURL(arrayBuffer) {
        window.URL = window.URL || window.webkitURL;
        window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;

        if (window.URL && (window.Blob || window.BlobBuilder)) {
            var blob = createBlob(arrayBuffer);
            return window.URL.createObjectURL(blob);
        }
    }
    function revokeObjectURL(objectUrl) {
        window.URL = window.URL || window.webkitURL;
        if (window.URL && objectUrl && objectUrl.startsWith('blob:'))
            window.URL.revokeObjectURL(objectUrl);
    }


})();

(function () {
    'use script';

    angular.event = JQLiteEvent;

    var JQLite = angular.element,
        slice = Array.prototype.slice,
        concat = Array.prototype.concat;

    function JQLiteEvent(element, eventName, extra) {
        if (!(this instanceof JQLiteEvent))
            return new (JQLiteEvent.bind.apply(JQLiteEvent, concat.apply([null], arguments)));

        this.target = element instanceof JQLite ? element[0] : element;
        this.type = eventName;

        angular.extend.apply(angular, [this].concat(slice.call(arguments, 2)));

        // Special case - rename "event" to "originalEvent"
        if (angular.isDefined(this.event)) {
            this.originalEvent = this.event;
            delete this.event;
        }
        return this;
    }

    JQLiteEvent.prototype = {
        preventDefault: function () { this.defaultPrevented = true; },
        isDefaultPrevented: function () { return this.defaultPrevented === true; },
        stopImmediatePropagation: function () { this.immediatePropagationStopped = true; },
        isImmediatePropagationStopped: function () { return this.immediatePropagationStopped === true; },
        stopPropagation: angular.noop
    }
})();